export type ICloseChildFormViaAjax = (button: IjQueryElmOrHtmlElm) => void;

export function _closeChildFormViaAjax(button: IjQueryElmOrHtmlElm): void {
  const $formGroup = $(button).closest('.form-group');
  const $form = $formGroup.closest('form');
  const $fieldSubForm = $formGroup.find('.fieldSubForm') as IjQueryElm;
  const $addSubFormButton = $fieldSubForm.find('.add-button.ajax-action');
  const $activeEditButton = $fieldSubForm.find('.edit-button.ajax-action.disabled');
  const $ajaxLoadFormHolder = $fieldSubForm.find('.ajax-load-form-holder');
  // Hide form
  $ajaxLoadFormHolder.addClass('hide');
  // Unfocus
  $('body').find('.modal-backdrop').remove();
  $formGroup.removeClass('z-index-1041');
  // Unanimate button
  window.DexeroCoreApp.animateButton($addSubFormButton, undefined, true);
  window.DexeroCoreApp.animateButton($activeEditButton, undefined, true);

  DCA.publish('/subform/closed', {
    form: $form,
    mainFieldSubFormHolder: $fieldSubForm,
    subFormFieldId: $formGroup.data('field-id'),
    subFormId: $fieldSubForm.data('form-id'),
  });
}
